import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api, { refreshMediaToken } from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get('/auth/me');
      setUser(res.data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('session_token', res.data.session_token);
    refreshMediaToken();
    setUser(res.data.user);
    return res.data.user;
  };

  const signup = async (email, password, name) => {
    const res = await api.post('/auth/signup', { email, password, name });
    localStorage.setItem('session_token', res.data.session_token);
    refreshMediaToken();
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch (e) {}
    localStorage.removeItem('session_token');
    localStorage.removeItem('media_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
